
import React from 'react'
import Footer from '../Footer'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/documentacionEmbarazada.scss'
import { Link } from "react-router-dom";

export default function DocumentacionEmbarazada() {

    return (
    <>
    
               
                  

        <section className='embarazadas-page'>

                {/* HERO */}
                <div className='embarazadas-hero'>

                    <div className='overlay'></div>

                    <div className='container hero-content'>

                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        <h1>
                            Documentación para mujeres embarazadas
                        </h1>

                        <p>
                            Garantizamos tu seguridad y bienestar durante
                            cada milla de tu travesía por el Mar de Cortés.
                        </p>

                    </div>

                </div>


                {/* CONTENT */}
                <div className='container embarazadas-content'>

                    <div className='embarazadas-layout'>

                        {/* MAIN */}
                        <div className='embarazadas-main'>


                            {/* ALERTA */}
                            <section className='embarazadas-alert'>

                                <div className='alert-icon'>
                                    <i className="fi fi-rs-shield-exclamation"></i>
                                </div>

                                <div>

                                    <h3>
                                        Restricción de Seguridad por Gestación
                                    </h3>

                                    <p>
                                        Por seguridad, si el tiempo de gestación
                                        es igual o mayor a <strong>28 semanas
                                        (7 meses)</strong> no se permite viajar.
                                    </p>

                                </div>

                            </section>


                            {/* REQUISITOS */}
                            <section>

                                <div className='section-title'>
                                    <i className="fi fi-rs-document"></i>
                                    <h2>Documentación requerida</h2>
                                </div>

                                <p className='section-description'>
                                    Para viajar es indispensable presentar
                                    la siguiente documentación:
                                </p>


                                <div className='requirements-grid'>

                                    {/* CARD */}
                                    <div className='requirement-card'>

                                        <i className="fi fi-rs-id-card"></i>

                                        <h3>
                                            Identificación oficial
                                        </h3>

                                        <ul>

                                            <li>
                                                INE o pasaporte
                                            </li>

                                            <li>
                                                Licencia de conducir
                                            </li>

                                            <li>
                                                Cédula profesional
                                            </li>

                                            <li>
                                                Cartilla militar
                                            </li>

                                        </ul>

                                    </div>


                                    {/* CARD */}
                                    <div className='requirement-card'>

                                        <i className="fi fi-rs-doctor"></i>

                                        <h3>
                                            Certificado médico
                                        </h3>

                                        <p>
                                            Expedido máximo 7 días antes
                                            del viaje.
                                        </p>

                                        <ul>

                                            <li>
                                                Nombre y semanas de gestación
                                            </li>

                                            <li>
                                                Fecha probable de parto
                                            </li>

                                            <li>
                                                Aprobación médica para viajar
                                            </li>

                                            <li>
                                                Datos y firma del médico
                                            </li>

                                        </ul>

                                    </div>

                                </div>

                            </section>


                            {/* NOTAS */}
                            <section className='notas-section'>

                                <div className='notas-header'>

                                    <i className="fi fi-rs-info"></i>

                                    <h3>
                                        Notas importantes
                                    </h3>

                                </div>

                                <div className='notas-grid'>

                                    <div className='nota-item'>

                                        <strong>
                                            Al comprar
                                        </strong>

                                        <p>
                                            Informa tu condición de embarazo
                                            al momento de adquirir tu boleto.
                                        </p>

                                    </div>

                                    <div className='nota-item'>

                                        <strong>
                                            Antes de abordar
                                        </strong>

                                        <p>
                                            El médico a bordo puede realizar
                                            una valoración preventiva antes
                                            del embarque.
                                        </p>

                                    </div>

                                </div>

                            </section>

                        </div>


                        {/* SIDEBAR */}
                        <aside className='embarazadas-sidebar'>

                            <div className='sidebar-card'>

                                <h3>
                                    Temas relacionados
                                </h3>

                                <nav>

                                    <Link to='/viajar-con-menores-de-edad'>
                                        <span>
                                            Viajar con menores de edad
                                        </span>
                                        <i class="fi fi-rs-arrow-small-right"></i>
                                    </Link>

                                    <Link to='/viajar-con-auto'>
                                        <span>
                                            Documentación para automóvil
                                        </span>
                                        <i class="fi fi-rs-arrow-small-right"></i>
                                    </Link>

                                    <Link to='/viajar-con-adulto-mayor'>
                                        <span>
                                            Viajar con adulto mayor
                                        </span>
                                        <i class="fi fi-rs-arrow-small-right"></i>
                                    </Link>

                                </nav>

                            </div>


                            <div className='sidebar-contact'>

                                <h3>
                                    ¿Necesitas ayuda?
                                </h3>

                                <div>

                                    <i className="fi fi-rs-phone-call"></i>

                                    <span>
                                        800 337 7437
                                    </span>

                                </div>

                                <div>

                                    <i className="fi fi-rs-envelope"></i>

                                    <span>
                                        contactcenter@bajaferries.com.mx
                                    </span>

                                </div>

                            </div>

                        </aside>

                    </div>

                </div>

                <Footer />
            </section>

               
    </>
    )
}
